const maskMobileNumber = (number) => {
  if (typeof number !== 'string') {
    number = String(number);
  }
  if (number.length === 10) {
    return number.slice(0, 3) + '******' + number.slice(-2);
  }
  return '-';
};

const maskEmail = (email) => {
  if (typeof email !== 'string' || !email.includes('@')) {
    return '-'; // Return a placeholder if the input is not a valid email
  }

  const [username, domain] = email.split('@');
  
  const maskedUsername = username.length > 1
    ? username[0] + '*'.repeat(username.length - 1)
    : username;

  const [domainName, domainExtension] = domain.split('.');
  const maskedDomainName = domainName.length > 1
    ? domainName[0] + '*'.repeat(domainName.length - 1)
    : domainName;

  return `${maskedUsername}@${maskedDomainName}.${domainExtension}`;
};

export { maskMobileNumber, maskEmail };
